
import { BarChart3, Brain, Trophy } from "lucide-react";
import { useIsMobile } from "@/hooks/use-mobile";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";

export const Features = () => {
  const isMobile = useIsMobile();

  const cards = [
    {
      icon: <BarChart3 className="h-12 w-12 text-primary mb-4" />,
      title: "Progress Analytics",
      description: "Track developmental milestones with detailed analytics and visualizations"
    },
    {
      icon: <Brain className="h-12 w-12 text-primary mb-4" />,
      title: "Research-Based",
      description: "Assessment tools built on proven research in child development"
    },
    {
      icon: <Trophy className="h-12 w-12 text-primary mb-4" />,
      title: "Achievement System",
      description: "Celebrate progress with achievement badges and accomplishments"
    }
  ];

  if (isMobile) {
    return (
      <Carousel className="w-full max-w-sm mx-auto">
        <CarouselContent>
          {cards.map((card, index) => (
            <CarouselItem key={index}>
              <div className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow text-center relative min-h-[280px]">
                <div className="flex justify-center">
                  {card.icon}
                </div>
                <h3 className="text-xl font-semibold mb-3">{card.title}</h3>
                <p className="text-gray-600 mb-12">{card.description}</p>
                <div className="absolute bottom-6 left-0 right-0 flex justify-center gap-4">
                  <CarouselPrevious className="static bg-white hover:bg-gray-50 border-gray-200" />
                  <CarouselNext className="static bg-white hover:bg-gray-50 border-gray-200" />
                </div>
              </div>
            </CarouselItem>
          ))}
        </CarouselContent>
      </Carousel>
    );
  }

  return (
    <>
      {cards.map((card, index) => (
        <div key={index} className="bg-white rounded-xl p-6 shadow-sm hover:shadow-md transition-shadow text-center">
          <div className="flex justify-center">
            {card.icon}
          </div>
          <h3 className="text-xl font-semibold mb-3">{card.title}</h3>
          <p className="text-gray-600">{card.description}</p>
        </div>
      ))}
    </>
  );
};
